import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import axios from "axios";

export const KeyMetrics = ({ queryParam }) => {
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalThreatActors, setTotalThreatActors] = useState(0);
  const [averageMonthlyRecords, setAverageMonthlyRecords] = useState(0);

  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_EAS_BASE_URL}/api/ransomware/count${queryParam}`,
        {
          headers: {
            apikey: process.env.REACT_APP_EAS_API_KEY,
            "X-CloudManager-Id": process.env.REACT_APP_EAS_CLOUD_ID,
          },
        }
      )
      .then((response) => {
        setTotalRecords(response.data.total_records);
      });

    axios
      .get(
        `${process.env.REACT_APP_EAS_BASE_URL}/api/ransomware/distinct-group-names${queryParam}`,
        {
          headers: {
            apikey: process.env.REACT_APP_EAS_API_KEY,
            "X-CloudManager-Id": process.env.REACT_APP_EAS_CLOUD_ID,
          },
        }
      )
      .then((response) => {
        setTotalThreatActors(response.data.distinct_group_names);
      });

    axios
      .get(
        `${process.env.REACT_APP_EAS_BASE_URL}/api/ransomware/average-monthly-records${queryParam}`,
        {
          headers: {
            apikey: process.env.REACT_APP_EAS_API_KEY,
            "X-CloudManager-Id": process.env.REACT_APP_EAS_CLOUD_ID,
          },
        }
      )
      .then((response) => {
        setAverageMonthlyRecords(response.data.average_monthly_records);
      });
  }, [queryParam]);

  return (
    <Container className={"my-4"} fluid>
      <Card className="d-flex flex-row flex-wrap flex-md-nowrap">
        <MetricContainer
          title={"Groups"}
          value={totalThreatActors?.toLocaleString()}
          border={true}
        />
        <MetricContainer
          title={"Average Victims per Month"}
          value={averageMonthlyRecords?.toFixed(2)?.toLocaleString()}
          border={true}
        />
        <MetricContainer
          title={"Total Incidents"}
          value={totalRecords?.toLocaleString()}
        />
      </Card>
    </Container>
  );
};

const MetricContainer = ({ title, value, border = false }) => {
  const borderStyle =
    border && window.innerWidth >= 768
      ? { borderRight: "1px solid #dee2e6" }
      : { borderRight: "0px solid #dee2e6" };

  return (
    <div className="my-3 px-5" style={borderStyle}>
      <Card.Title className="small fw-normal mb-2">{title}</Card.Title>
      <Card.Subtitle className="p fw-semibold">{value}</Card.Subtitle>
    </div>
  );
};
